export default __webpack_public_path__ + "static/media/loading-orange.72b022b3.svg";